import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TeammateDetails } from 'src/app/models/teammate.model';
import { TeammateService } from 'src/app/services/teammate.service';

@Component({
  selector: 'app-teammate-information',
  templateUrl: './teammate-information.component.html',
  styleUrls: ['./teammate-information.component.scss'],
  standalone: false
})
export class TeammateInformationComponent {
  private _teammateID: string = '';
  @Output() isLoadingInformation = new EventEmitter<boolean>();
  @Input()
  set teammateID(id: string) {
    // Only fetch if the ID is valid and has changed.
    if (id && id !== this._teammateID) {
      this._teammateID = id;
      this.isLoading = true;
      this.showNoResults = false;
      this.getTeammateInformation(id);
    }
  }
  get teammateID(): string {
    return this._teammateID;
  }

  teammateInformation: TeammateDetails = {} as TeammateDetails;
  isLoading: boolean = false;
  showNoResults: boolean = false;

  constructor(private teammateService: TeammateService) {}
  getTeammateInformation(teammateId: string): void {
    this.isLoadingInformation.emit(true);
    this.teammateService.getTeammateDetails(teammateId).subscribe({
      next: (teammateInfo: any) => {
        if (teammateInfo && teammateInfo.result && teammateInfo.result.length > 0) {
          this.teammateInformation = teammateInfo.result[0];
          this.showNoResults = false;
        } else {
          this.teammateInformation = {} as TeammateDetails;
          this.showNoResults = true;
        }
        this.isLoading = false;
        this.isLoadingInformation.emit(false);
      },
      error: (error) => {
        console.error('Error searching for teammate:', error);
        this.teammateInformation = {} as TeammateDetails;
        this.showNoResults = true;
        this.isLoading = false;
        this.isLoadingInformation.emit(false);
      }
    });
  }

  getFacilityAddress(role: any): string {
    const address = [role.facilityAddress1, role.facilityAddress2, role.city, role.state]
      .filter(part => part && part.trim())
      .join(', ');
    return address;
  }
}
